/**
 * Single source of truth for the "manually changed" purple indicator shown
 * across the app:
 *  - discography table rows (MasterDiscography `getRowStyle`)
 *  - the recording edit form fields/chips
 *  - the release edit form fields/chips
 *
 * The visual attributes (colour + line width) live as CSS custom properties in
 * `global.css` (`--color-manual-change`, `--manual-change-line-width`). Both
 * the CSS-driven left line (`.manual-change-line::before`) and the JS-driven
 * ag-grid row style below reference those same variables, so changing the
 * look & feel only requires editing the variables in `global.css`.
 */

/** Class that draws the purple left line via a `::before` pseudo-element.
 *  Apply it to a relatively-positioned wrapper around the edited element
 *  (inputs/selects, which can't host `::before`, must be wrapped). */
export const MANUAL_CHANGE_LINE_CLASS = 'manual-change-line';

/** Inset box-shadow drawing the same left line on an element that can't use a
 *  pseudo-element (e.g. an ag-grid row). Uses the shared CSS variables so it
 *  stays in sync with `.manual-change-line`. */
export const MANUAL_CHANGE_BOX_SHADOW =
  'inset var(--manual-change-line-width) 0 0 0 var(--color-manual-change)';

/** Convenience style object for ag-grid `getRowStyle`. */
export const MANUAL_CHANGE_ROW_STYLE = {
  boxShadow: MANUAL_CHANGE_BOX_SHADOW,
};
